import { render, staticRenderFns } from "./materialSupplyComparison.vue?vue&type=template&id=3b201362&scoped=true"
import script from "./materialSupplyComparison.vue?vue&type=script&lang=js"
export * from "./materialSupplyComparison.vue?vue&type=script&lang=js"
import style0 from "./materialSupplyComparison.vue?vue&type=style&index=0&id=3b201362&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b201362",
  null
  
)

export default component.exports